import { render, staticRenderFns } from "./CompanyTaxSettings.vue?vue&type=template&id=2e10e574&scoped=true&"
import script from "./CompanyTaxSettings.vue?vue&type=script&lang=js&"
export * from "./CompanyTaxSettings.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTaxSettings.vue?vue&type=style&index=0&id=2e10e574&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e10e574",
  null
  
)

export default component.exports